import { SearchDepartment } from '@moonpig/web-core-nav/src/Search'

const ELIGIBLE_ITEM_TYPES = ['search-fallback', 'search'] as const
const SUGGESTION_ITEM_TYPE = 'suggestion' as const

const isEligibleItemType = (itemType?: string): boolean =>
  !itemType ||
  ELIGIBLE_ITEM_TYPES.includes(
    itemType as (typeof ELIGIBLE_ITEM_TYPES)[number],
  ) ||
  itemType === SUGGESTION_ITEM_TYPE

/* istanbul ignore next */
const isFacetSuggestion = (suggestion: string): boolean => {
  return suggestion.split(':').length > 1
}

const hasDepartmentBeenSelected = (department?: SearchDepartment): boolean =>
  department?.activeDepartment?.name !== undefined &&
  department?.activeDepartment?.name !== 'all'

export const allowSmartDepartmentRedirect = ({
  itemType,
  department,
  params,
}: {
  itemType: string | undefined
  department?: SearchDepartment
  params: { suggestion: string }
}): boolean => {
  const { suggestion } = params

  return (
    isEligibleItemType(itemType) &&
    !isFacetSuggestion(suggestion) &&
    !hasDepartmentBeenSelected(department)
  )
}
